export const HOTEL_LOCATION_TYPES = {
    location: 'locationAndCountry',
    country: 'locationAndCountry',
    hotel: 'hotel',
    category: 'theme',
    'location-category': 'theme',
};
